interface IScalesHeightKpiTable {
  menuToggle: boolean
  isGraphic: boolean
  hasSessions: boolean
}

export const scalesHeightKpiTable = ({
  menuToggle,
  isGraphic,
  hasSessions
}: IScalesHeightKpiTable) => {
  if (menuToggle && isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 463px)'
    }
    return 'calc(100vh - 432px)'
  }

  if (!menuToggle && isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 604px)'
    }
    return 'calc(100vh - 573px)'
  }

  if (menuToggle && !isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 167px)'
    }
    return 'calc(100vh - 136px)'
  }

  if (!menuToggle && !isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 308px)'
    }
    return 'calc(100vh - 277px)'
  }
}
